import React, { useState, useEffect } from 'react';
import { ArrowLeftRight, ArrowUpDown, ArrowDownUp, Minus } from 'lucide-react';

function StockMovements() {
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMovements();
  }, []);

  const fetchMovements = async () => {
    try {
      const res = await fetch('/inventory-app/api/stock-movements');
      const data = await res.json();
      setMovements(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching movements:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">Stock Movements</h1>
        <p className="text-slate-500 mt-1">Track all inventory changes</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-100 bg-slate-50">
                <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Date</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Product</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">SKU</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Type</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Quantity</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Previous</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">New</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Reason</th>
              </tr>
            </thead>
            <tbody>
              {movements.map((movement) => (
                <tr key={movement.id} className="border-b border-slate-50 hover:bg-slate-50">
                  <td className="py-3 px-4 text-sm text-slate-500">
                    {new Date(movement.created_at).toLocaleDateString('en-US', {
                      month: 'short', day: 'numeric', year: 'numeric',
                      hour: '2-digit', minute: '2-digit'
                    })}
                  </td>
                  <td className="py-3 px-4 text-sm font-medium text-slate-900">{movement.product_name}</td>
                  <td className="py-3 px-4 text-sm text-slate-500">{movement.sku}</td>
                  <td className="py-3 px-4">
                    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                      movement.type === 'IN' ? 'bg-emerald-100 text-emerald-700' :
                      movement.type === 'OUT' ? 'bg-red-100 text-red-700' :
                      'bg-amber-100 text-amber-700'
                    }`}>
                      {movement.type === 'IN' && <ArrowUpDown className="w-3 h-3" />}
                      {movement.type === 'OUT' && <ArrowDownUp className="w-3 h-3" />}
                      {movement.type === 'ADJUSTMENT' && <Minus className="w-3 h-3" />}
                      {movement.type}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm font-medium text-slate-900">{movement.quantity}</td>
                  <td className="py-3 px-4 text-sm text-slate-500">{movement.previous_quantity}</td>
                  <td className="py-3 px-4 text-sm font-medium text-slate-900">{movement.new_quantity}</td>
                  <td className="py-3 px-4 text-sm text-slate-500">{movement.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default StockMovements;
